import { createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { AiAppDetailPage } from "@/features/ai-apps/detail/ai-app-detail-page";

export const Route = createFileRoute("/ai-apps/$appId")({
  component: () => (
    <PermissionGuard module="ai_apps">
      <AiAppDetailPage />
    </PermissionGuard>
  ),
});
